import { render, staticRenderFns } from "./cuadrilla.vue?vue&type=template&id=0f860569"
import script from "./cuadrilla.vue?vue&type=script&lang=js"
export * from "./cuadrilla.vue?vue&type=script&lang=js"
import style0 from "./cuadrilla.vue?vue&type=style&index=0&id=0f860569&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports